<div class="bg-white rounded-xl w-full h-full p-4 relative">Support</div>
